import { useEffect, useState } from 'react'

const MOBILE_QUERY = '(max-width: 767px)'
const TABLET_QUERY = '(max-width: 1023px)'

const currentLayout = () => {
	if (typeof window === 'undefined') return 'desktop'
	if (window.matchMedia(MOBILE_QUERY).matches) return 'mobile'
	if (window.matchMedia(TABLET_QUERY).matches) return 'tablet'
	return 'desktop'
}

/** Which of the load card's layouts fits the screen: mobile, tablet or desktop. */
export default function useBoardLayout() {
	const [layout, setLayout] = useState(currentLayout)

	useEffect(() => {
		if (typeof window === 'undefined') return
		const mobileQuery = window.matchMedia(MOBILE_QUERY)
		const tabletQuery = window.matchMedia(TABLET_QUERY)
		const syncLayout = () => setLayout(currentLayout())

		if (mobileQuery.addEventListener) {
			mobileQuery.addEventListener('change', syncLayout)
			tabletQuery.addEventListener('change', syncLayout)
			return () => {
				mobileQuery.removeEventListener('change', syncLayout)
				tabletQuery.removeEventListener('change', syncLayout)
			}
		}
		// Safari < 14 fallback
		mobileQuery.addListener(syncLayout)
		tabletQuery.addListener(syncLayout)
		return () => {
			mobileQuery.removeListener(syncLayout)
			tabletQuery.removeListener(syncLayout)
		}
	}, [])

	return { isMobile: layout === 'mobile', isTablet: layout === 'tablet' }
}
